import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_2106_3244)\"><path d=\"M20 0H0V20H20V0Z\" fill=\"white\" fill-opacity=\"0.01\"></path><path d=\"M5.83337 5.83337L14.1667 14.1667\" stroke=\"#1D2522\" stroke-width=\"1.66667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.83337 14.1667L14.1667 5.83337\" stroke=\"#1D2522\" stroke-width=\"1.66667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_2106_3244\"><rect width=\"20\" height=\"20\" fill=\"white\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }